import React from "react";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "../../components/LanguageSelector";

export const LanguageSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col lg:flex-row gap-8">
      {/* Label - Figma: max-w-280px */}
      <div className="w-full lg:w-[280px] shrink-0">
        <h3 className="text-sm font-semibold text-text-secondary dark:text-text-secondary leading-5 mb-1">
          {t("settings.appearance.language")}
        </h3>
        <p className="text-sm text-text-tertiary dark:text-text-tertiary leading-5">
          {t("settings.appearance.languageDescription")}
        </p>
      </div>

      {/* Language Dropdown */}
      <div className="flex-1 min-w-0">
        <LanguageSelector />
      </div>
    </div>
  );
};
